// extracted by mini-css-extract-plugin
export default {"container":"ErrorPage_container__+gMBN","image":"ErrorPage_image__FTOc5","title":"ErrorPage_title__tyR1e","description":"ErrorPage_description__ZY2Se"};